<template>
  <nav v-if="items.length" class="app-breadcrumb w-80" aria-label="Breadcrumb">
    <ol class="bc-list">
      <li class="bc-item">
        <router-link to="/" class="bc-link" aria-label="Início">
          <i class="pi pi-home"></i>
        </router-link>
      </li>
      <li v-for="(item, i) in items" :key="i" class="bc-item">
        <i class="pi pi-chevron-right bc-separator"></i>
        <router-link v-if="item.to" :to="item.to" class="bc-link">{{ item.label }}</router-link>
        <span v-else class="bc-current">{{ item.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useLaboratoryStore } from '@/stores/laboratoryStore';
import { useExerciseStore } from '@/stores/exercise';

const route = useRoute();
const labStore = useLaboratoryStore();
const exerciseStore = useExerciseStore();

const items = computed(() => {
  const name = route.name;

  if (name === 'ListExercises') {
    return [
      { label: labStore.currentLab?.title || 'Exercícios' }
    ];
  }

  if (name === 'Exercise') {
    const labSlug = labStore.currentLab?.slug;
    return [
      {
        label: labStore.currentLab?.title || 'Exercícios',
        to: labSlug ? `/laboratorio/${labSlug}` : '/'
      },
      { label: exerciseStore.currentExercise?.title || 'Exercício' }
    ];
  }

  return [];
});
</script>

<style scoped>
.app-breadcrumb {
  margin: 1rem auto 0.5rem;
}

.bc-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.875rem;
}

.bc-item {
  display: flex;
  align-items: center;
}

.bc-separator {
  font-size: 0.6rem;
  color: #b0b8c4;
  margin: 0 0.5rem;
}

.bc-link {
  color: #1A5FD5;
  text-decoration: none;
  transition: color 0.2s;
  display: flex;
  align-items: center;
}

.bc-link:hover {
  color: #134bb0;
}

.bc-link .pi-home {
  font-size: 0.95rem;
}

.bc-current {
  color: #6c757d;
  font-weight: 500;
}
</style>
